import { render, staticRenderFns } from "./TutorSendMail.vue?vue&type=template&id=2065c76c&scoped=true"
import script from "./TutorSendMail.vue?vue&type=script&lang=ts"
export * from "./TutorSendMail.vue?vue&type=script&lang=ts"
import style0 from "./TutorSendMail.vue?vue&type=style&index=0&id=2065c76c&prod&lang=css"
import style1 from "./TutorSendMail.vue?vue&type=style&index=1&id=2065c76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2065c76c",
  null
  
)

export default component.exports